module.exports = __webpack_public_path__ + "static/img/agent-icon.d957715c.svg";